import { Link } from 'react-router-dom';
import { ArrowUpRight } from '@phosphor-icons/react';
import { NAV_ITEMS, PROJECTS, SITE } from '../data/site';
import Container from './ui/Container';

const LINK = 'text-[15px] text-white/65 transition-colors hover:text-white';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-night text-white">
      <Container className="py-14 sm:py-16">
        <div className="grid gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5">
            <Link to="/" className="inline-flex items-center gap-2" aria-label="PageN 홈으로">
              <img src="/logo.png" alt="" width={32} height={28} className="h-7 w-auto" />
              <span className="text-[19px] font-bold tracking-tight">PageN</span>
            </Link>
            <p className="mt-4 max-w-sm text-[15px] leading-[1.7] text-white/65">
              홈페이지, 관리 시스템, 포트폴리오를 기획부터 배포까지 한 팀이 맡아 만드는 웹 제작 스튜디오입니다.
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="text-[13px] font-semibold text-white/45">메뉴</p>
            <ul className="mt-4 space-y-2.5">
              {NAV_ITEMS.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className={LINK}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-[13px] font-semibold text-white/45">프로젝트</p>
            <ul className="mt-4 space-y-2.5">
              {PROJECTS.map((project) => (
                <li key={project.slug}>
                  <a href={project.url} target="_blank" rel="noreferrer" className={`inline-flex items-center gap-1 ${LINK}`}>
                    {project.name}
                    <ArrowUpRight size={14} weight="bold" className="text-white/40" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-[13px] font-semibold text-white/45">문의</p>
            <ul className="mt-4 space-y-2.5">
              <li>
                <a href={`mailto:${SITE.email}`} className={LINK}>
                  {SITE.email}
                </a>
              </li>
              <li>
                <a href={SITE.kakao} target="_blank" rel="noreferrer" className={`inline-flex items-center gap-1 ${LINK}`}>
                  카카오톡 오픈채팅
                  <ArrowUpRight size={14} weight="bold" className="text-white/40" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-night-line pt-6 text-[13px] leading-6 text-white/50 sm:flex-row sm:items-center sm:justify-between">
          <p>
            상호명 {SITE.business.company}
            <span className="mx-2 text-white/25">|</span>
            대표 {SITE.business.ceo}
            <span className="mx-2 text-white/25">|</span>
            사업자등록번호 {SITE.business.registration}
          </p>
          <p>© {year} PageN. All rights reserved.</p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
